import { useContext, useState } from "react";
import {
  BoldLinkB,
  BoxContainerB,
  FormContainerB,
  InputB,
  MutedLinkB,
  SubmitButtonB,
} from "./Components";
import { Marginer } from "./marginer";
import { AccountContext } from "./accountContext";
import { useSelector, useDispatch } from 'react-redux'
import { customer_login} from '../../store/reducers/authReducer'
// import { useNavigate } from 'react-router-dom'

import HashLoader from 'react-spinners/HashLoader'
import { RiEyeCloseFill, RiEyeFill } from "react-icons/ri";

export function LoginForm() {
  const { switchToSignup } = useContext(AccountContext);
  const { loader } = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const [state, setState] = useState({
    email: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    })
  }
  const login = (e) => {
    e.preventDefault()
    dispatch(customer_login(state))
  }

  return (
    <>
      {
        loader && <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
          <HashLoader color='#BD5344' />
        </div>
      }
      <BoxContainerB>
        <FormContainerB onSubmit={login}>
          <InputB onChange={inputHandle} value={state.email} type="email" id='email' name='email' placeholder='Email' />
          <div className="flex items-center relative">
            <InputB onChange={inputHandle} value={state.password} type={showPassword ? 'text' : 'password'} id='password' name='password' placeholder='Password' />
            <button
              type='button'
              className='absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-800'
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
            </button>
          </div>
        </FormContainerB>
        <Marginer direction="vertical" margin={10} />
        <Marginer direction="vertical" margin="1.6em" />
        <SubmitButtonB onClick={login}>Signin</SubmitButtonB>
        <Marginer direction="vertical" margin="1em" />
        <MutedLinkB href="#">
          Don't have an account?{" "}
          <BoldLinkB href="#" onClick={switchToSignup}>
            Signup here
          </BoldLinkB>
        </MutedLinkB>
      </BoxContainerB>
    </>
  );
}
